import React, { Component } from 'react'
import { Button,Row,Col } from "reactstrap";
import LessonCard from "../LessonCard";

export default class PreviewItem extends Component {
    state = {
        singleItem:{
            index:0,
            itemCode: `ACT-E-Q${0}`,
            itemType: 'Multiple Choice',
            preview: `Oh, king eh? Very nice. 
                        And how'd you get that, 
                        eh? By exploiting the workers. 
                        <span className='underlined_item'>By hanging on to outdated</span> imperialist dogma 
                        which perpetuates the economic and social differences 
                        in our society. If there's ever gonna be any progress...`,
            tags: 'hard-question, mess-these-kids-up, questionable-answer',
            nodes: `Writer's Goal`,
            answerChoices: {
                answer001: 'Bring out your dead',
                answer002: `Well you can't expect to wield supreme executive power just 'cause some watery tart threw a sword at you!`,
                answer003: `Come back here and take what's coming to you. I'll bite your legs off!`,
                answer004: `All right, all right, not biscuits, but lets kill him anyway.`
            }
        }
    }

    render() {
        const {
            singleItem
        } = this.state

        return (
            <React.Fragment>
                        <LessonCard
                            iconClass={`preview-icon`}
                            heading={`Preview Item`}
                            isCollapsable={false}
                            headerButtons={[
                                <Button className={`add-btn`}>+ Edit Item</Button>
                            ]}

                        >
                            <div className='items-bank-right-container' style={{ height: 'unset' }}>
                                    <div className='item-card' style={{ margin: '20px 0px 20px 0px' }}>
                                        <Row>
                                            <Col sm='2' md='2' className='item-label'>
                                                Item Code:
                                            </Col>
                                            <Col xs='12' sm='9' md='9' className='item-desc'>
                                                <strong>{singleItem.itemCode}</strong>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm='2' md='2' className='item-label'>
                                                Item Type:
                                            </Col>
                                            <Col xs='12' sm='9' md='9' className='item-desc'>
                                                {singleItem.itemType}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm='2' md='2' className='item-label'>
                                                Tags:
                                            </Col>
                                            <Col xs='12' sm='9' md='9' className='item-desc'>
                                                {singleItem.tags}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm='2' md='2' className='item-label'>
                                                Nodes:
                                            </Col>
                                            <Col xs='12' sm='9' md='9' className='item-desc'>
                                                {singleItem.nodes}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm='2' md='2' className='item-label'>
                                                Preview:
                                            </Col>
                                            <Col xs='12' sm='9' md='9' className='item-desc'>
                                                <div dangerouslySetInnerHTML={{ __html: singleItem.preview }}></div>
                                                {Object.keys(singleItem.answerChoices).map((key, i) => {
                                                    let answers = ['A', 'B', 'C', 'D']
                                                    return (
                                                        <div className='answers'>
                                                            <div className='answer-circle'>{answers[i]}</div>
                                                            <div className='answer-choice'>{singleItem.answerChoices[key]}</div>
                                                        </div>
                                                    )
                                                })}
                                            </Col>
                                        </Row>
                                    </div>
                            </div>
                        </LessonCard>
                    
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorLesson/PreviewItem.js